// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__v6Gzo","head":"ProcedureTableInfo_head__2fFbU"};